import React from 'react';
import { useSchoolData } from './SchoolDataProvider';
import AssignmentCard from './AssignmentCard';

// Anything the student flagged as "I'm stuck" — the same collection as Today,
// just a different filter, so a parent (or the student) can see what needs
// attention without paging through every day.
export default function FlaggedPage() {
  const { flagged, courseFor, familyId, loading } = useSchoolData();

  if (loading) return <p className="db-item-sub">Loading…</p>;

  if (flagged.length === 0) {
    return (
      <div className="db-card db-rest">
        <h2>All caught up</h2>
        <p>Nothing flagged.</p>
      </div>
    );
  }

  const sorted = flagged.slice().sort((a, b) => (a.date || '').localeCompare(b.date || ''));

  return (
    <ul className="db-items db-card" style={{ padding: '4px 12px' }}>
      {sorted.map(a => (
        <AssignmentCard key={a.id} a={a} course={courseFor(a)} familyId={familyId} />
      ))}
    </ul>
  );
}
